export const TYPES = {
  ACTION_ITEM_TYPE_OPEN_ACCOUNT: 'open-account',
  ACTION_ITEM_TYPE_OPEN_AND_FUND_ACCOUNT: 'open-and-fund-account',
  ACTION_ITEM_TYPE_RETITLE_ACCOUNT: 'retitle-account',
  ACTION_ITEM_TYPE_FUND_ACCOUNT: 'fund-account',
  ACTION_ITEM_TYPE_ONBOARDING: 'onboarding',
  ACTION_ITEM_TYPE_CASHFLOW_BUDGET: 'cashflow-budget',
  ACTION_ITEM_TYPE_DEBT: 'debt',
  ACTION_ITEM_TYPE_INVESTMENTS: 'investments',
  ACTION_ITEM_TYPE_EDUCATION: 'education',
  ACTION_ITEM_TYPE_EMPLOYEEBENEFITS: 'employee-benefits',
  ACTION_ITEM_TYPE_INSURANCE: 'insurance',
};

export default {
  TYPES,
};
